import client from './client';

export default (function UserSpecialtiesService() {
  let service;

  if (!service) {
    service = client.service('userSpecialties');
  }

  return service;
}());
